/**
 * Survey Lines
 */
angular.module('elogbooksDirectives').directive('surveyLines', ['$http', 'apiClient', function ($http, apiClient) {
    return {
        restrict: 'A',
        require: ['ngModel'],
        scope: {
            ngModel: '=',
            editable: '='
        },
        templateUrl: '/modules/directives/survey/lines/lines.html'
    };
}]);
